/* ============================================================================
   dntk-premium.js · DNTK-Radio & TV · Fassung 2026-10-25 (Radio und Ton einer Karte halten sich gegenseitig an, ohne
   sich auf das play-Ereignis des Tonspielers zu verlassen: in der Android-App liefen sonst beide parallel;
   vorher 2026-10-24: Weiter ab und Umschalter Nur Ton/Mit Bild in den PLUS-Karten;
   vorher 2026-10-06b: Rundlauf: Nach dem letzten Titel eines Albums geht es ohne Pause beim ersten weiter; Bedienung unter dem Cover: Abspielen/Pause, Zeit und Fortschrittslinie in der Zeile neben „Teilen“, die Leiste des Tonspielers über dem Cover entfällt; Alben und Staffeln: Tasten „Titel zurück“ und „Titel vor“ in derselben Zeile, flach und breit; Sperrbildschirm: Titel-Tasten wie im Radio statt Spul-Tasten; Ton läuft wie im Radio über ein Audio-Element mit stillem Dauerton; nächster Albumtitel startet ohne Pause, auch im Hintergrund; Etappe 5d: Videos der Angebotskarten im Hintergrund als Ton; Sperrbildschirm; Etappe 5c: Ton eines Videos; Besitz je Angebot; sichtbar „PLUS“; Etappe 5a; Etappe 2)
   Die Premium-Engine: Kauf, Zugang und Abspielen gibt es im Theme genau einmal.
   Sections markieren nur, was Premium ist; die Engine erledigt den Rest.

   Herausgelöst aus sections/dntk-premium.liquid v2 (Team M-Partner, 25.09.2026).
   Kauflogik, Texte, Aufladen, Verkäuferkennung und Signatur-Erneuerung sind Zeile für
   Zeile übernommen. Neu: ein Aufruf premium-bibliothek je Seite statt einer Prüfung je Folge
   (Rückfall auf die Prüfung je Folge, falls die Bibliothek nicht antwortet).

   Braucht einmal je Seite:  {% render 'dntk-premium-konfig' %}
   Ohne Anmeldung ruft die Engine Supabase nie auf. hls.js wird erst beim Abspielen geladen.

   Oeffentlich (für Radio, Gallery, Bibliothek in späteren Etappen):
     DNTKPremium.besitz(frisch)          -> Promise { medien: {m: {...}}, angebote: {handle: 'ganz'|'teil'} } | null
     DNTKPremium.markiere(wurzel)        -> Kronen [data-premium-marke] auf Häkchen setzen, wo gekauft
     DNTKPremium.zugang(m, frisch, ton)  -> Promise { status, url, art } signierte Adresse (Video: HLS, Audio: Datei;
                                            ton = true: bei Videos mit Tondatei der reine Ton, art "ton", Etappe 5c)
     DNTKPremium.kaufen(variante, handle) -> Promise { status, j } (premium-kaufen; Variante oder Angebots-Handle)
     DNTKPremium.kennung()               -> Verkäuferkennung (liest mm_vk nur)
     DNTKPremium.neuerPlayer(video, h)   -> { spiele(m, info, sofort), stoppe(), alsTon(laufen), mitBild(laufen), art(),
                                              medium() (das Element, das gerade spielt), audio (Tonspieler) }
                                            (info.ton = true: Video gleich als Ton, Etappe 5d)
     DNTKPremium.bindeAngebot(wurzel)    -> Section dntk-premium-angebot verdrahten

   Sperrbildschirm (Media Session): Spielt eine Angebotskarte, meldet die Engine Titel, Künstler, Album
   und Cover ans Handy (Sperrbildschirm, Benachrichtigung, Auto/Bluetooth) mit Abspielen/Pause und
   Fortschritt. Album und Staffel: Titel vor/zurück, dieselben Tasten wie im Radio (05.10.2026: Spulen wird
   dort nicht mehr angemeldet, weil iPhones sonst die Spul-Tasten anstelle der Titel-Tasten zeigen).
   Einzelfolge: 15 s zurück, 30 s vor. Läuft auf der Seite das Radio, hält die Karte es an; startet danach
   das Radio oder ein anderes Medium, hält die Karte an und gibt die Bedienung an das Radio zurück.

   Titel-Tasten (05.10.2026, Fassung c und d): Hat ein Angebot mehr als einen Titel, legt die Engine zwei
   Tasten „Titel zurück“ und „Titel vor“ in die Zeile unter dem Medienfeld (.dp__kopf), links neben
   „Teilen“. Sie erscheinen, sobald die Karte spielt, und stehen dann an der Stelle der kleinen Zeile
   „DNTK-PLUS · DNTK Records“. So liegt nichts mehr über Cover oder Video (Fassung b hatte die Tasten im
   Medienfeld). Fassung d: flach und breit mit abgerundeten Ecken (46 × 26 px, so hoch wie „Teilen“) statt
   rund (36 px), damit sie nicht an den Titel darunter stoßen; die Tippfläche ist 34 px hoch.
   Sie tun dasselbe wie die Tasten im Sperrbildschirm. Die Section bleibt unverändert; fehlt ihr die
   Zeile, liegen die Tasten wie in Fassung b rund im Medienfeld.

   Bedienung unter dem Cover (06.10.2026): Damit beim Abspielen das ganze Cover zu sehen ist, bekommt der
   Tonspieler der Angebotskarten keine eigene Leiste mehr. Stattdessen stehen in der Zeile unter dem
   Medienfeld: „Titel zurück“ (nur Album), Abspielen/Pause, „Titel vor“ (nur Album) und die Zeit; rechts
   bleibt „Teilen“. Die Zeit zeigt „1:33 / 3:33“, wenn der Platz reicht, sonst nur die gespielte Zeit.
   Im Spalt zwischen Medienfeld und Zeile liegt eine dünne Fortschrittslinie zum Antippen und Ziehen
   (Griff nur beim Bedienen sichtbar); bei Videos mit Bild fehlt sie, dort bleibt die Bedienung des Videos.
   Einzelfolgen bekommen Abspielen/Pause, Zeit und Linie ebenfalls. Keine neuen Ereignis-Arten: die
   Anzeige hängt an play, pause, timeupdate und loadedmetadata. Fehlt der Section die Zeile (.dp__kopf),
   bleibt alles wie in Fassung d (Leiste des Tonspielers, runde Titel-Tasten im Medienfeld). Die Bibliothek
   nutzt neuerPlayer direkt und behält ihre Leiste.

   Rundlauf (06.10.2026, Fassung b): Ein Album oder eine Staffel hört nicht mehr nach dem letzten Titel
   auf. Nach dem letzten freigeschalteten Titel spielt der erste weiter, auf demselben Weg wie jeder
   Titelwechsel (eine halbe Sekunde vor dem Ende, Adresse vorgeholt, auch im Hintergrund). „Titel vor“ in
   der Karte und im Sperrbildschirm springt am letzten Titel ebenfalls zum ersten und ist nur noch
   ausgegraut, wenn bloß ein Titel freigeschaltet ist. „Titel zurück“ bleibt am ersten Titel stehen.
   Einzelfolgen laufen wie bisher einmal durch.

   Etappe 5d (Hintergrund): Handys halten Videos an, sobald die Seite verschwindet (Sperrbildschirm,
   App-Wechsel); reiner Ton läuft weiter. Spielt in einer Karte ein Video mit Tondatei, geht es dann an
   derselben Stelle als Ton weiter (auch über „Abspielen“ im Sperrbildschirm und beim nächsten Albumtitel);
   zurück auf der Seite wieder mit Bild. Ohne Tondatei und im Bild-im-Bild bleibt alles wie bisher.

   Nächster Titel ohne Pause (02.10.2026): Ist ein Albumtitel zu Ende, legt das Handy eine Seite im
   Hintergrund schlafen, sobald nichts mehr spielt. Deshalb holt die Karte die Adresse des nächsten
   freigeschalteten Titels schon während der laufende spielt (und noch einmal kurz vor dessen Ende, falls
   sie fehlt). Am Ende wechselt sie im selben Augenblick: neue Adresse setzen und sofort abspielen, ohne
   Anfrage und ohne Warten auf die Datei. Liegt keine Adresse bereit, läuft der bisherige Weg.

   Ton wie im Radio (02.10.2026, Fassung b): Handys lassen ein <video> im Hintergrund nicht von selbst
   zum nächsten Titel starten, ein <audio> schon. Deshalb spielt die Karte Audio-Dateien und die
   Tondateien von Videos jetzt in einem eigenen <audio>-Element (Tonspieler, liegt im Medienfeld über
   dem Cover); das <video> zeigt nur noch Videos mit Bild. Dazu drei Dinge genau wie im Radio:
   ein stiller Dauerton hält die Seite wach, solange eine Karte spielt; der Wechsel zum nächsten Titel
   passiert eine halbe Sekunde vor dem Ende, solange der laufende noch spielt (ended bleibt als Rückfall);
   und der Start wird nach 50 ms noch einmal angestoßen. Der Tonspieler wird beim ersten Fingertipp
   mit Stille freigeschaltet (iOS erlaubt play() sonst nur im Klick). Kein canplay.

   Weiter ab (24.10.2026): Die Karte merkt sich die Stelle jedes Titels ab 10 Minuten Laufzeit, in
   denselben Stellen wie Radio und Bibliothek (localStorage dntk_premium_pos, je Kennung { p, d, t }).
   Der Knopf eines freigeschalteten Titels heißt dann „Weiter ab 20:09“ (mit dünnem Fortschrittsbalken)
   und startet den Titel an dieser Stelle; der Knopf im Cover nennt die Stelle des zuletzt gehörten Titels
   der Karte und spielt dort weiter. In den letzten 30 s und beim
   Wechsel zum nächsten Titel wird die Stelle gelöscht (zu Ende gehört); unter 15 s bleibt die alte.
   Gemerkt wird bei Pause, alle 5 s beim Spielen, beim Titelwechsel, beim Verbergen und beim Verlassen
   der Seite; nie in den ersten 4 s nach einem Start oder Umschalten.

   Nur Ton / Mit Bild (24.10.2026): Bei Videos mit Tondatei steht in der Zeile unter dem Medienfeld ein
   Umschalter. „Nur Ton“ wechselt an derselben Stelle auf die Tondatei (Cover, Leiste, läuft auch bei
   gesperrtem Handy), „Mit Bild“ zurück. Die Wahl gilt für die Karte, auch für die nächsten Titel; zurück
   auf der Seite bleibt es dann beim Ton (5d wechselt nur zurück, wenn der Ton automatisch kam). Gibt es
   noch keine Tondatei, sagt die Karte es und bleibt beim Bild.

   Regeln: Übergabe-Protokoll https://claude.ai/code/artifact/e5984669-eb75-4205-a1dd-857024ef1eaf
   ============================================================================ */
(function () {
  'use strict';
  if (window.DNTKPremium) { return; }

  var konfigEl = document.querySelector('[data-dntk-premium-konfig]');
  var K = {};
  try { K = JSON.parse(konfigEl ? konfigEl.textContent : '{}') || {}; } catch (e) { K = {}; }

  var BASIS   = String(K.basis || '').replace(/\/+$/, '');
  var AKTIV   = !!(K.bereit && K.angemeldet && K.kunde && K.sig && BASIS);
  var HLS_SRC = 'https://cdn.jsdelivr.net/npm/hls.js@1/dist/hls.min.js';

  /* ------------------------------------------------------------------ Hilfen */
  function euro(cent) {
    cent = Math.round(Number(cent) || 0);
    if (cent % 100 === 0) { return (cent / 100) + ' €'; }
    return (cent / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  function zuCent(text) { return Math.round((parseFloat(text) || 0) * 100); }
  function warte(ms) { return new Promise(function (ok) { setTimeout(ok, ms); }); }
  function lies(k) { try { return sessionStorage.getItem(k) || ''; } catch (e) { return ''; } }
  function schreib(k, v) { try { if (v === null) { sessionStorage.removeItem(k); } else { sessionStorage.setItem(k, v); } } catch (e) {} }

  function rufe(fn, daten) {
    return fetch(BASIS + '/functions/v1/' + fn, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(daten),
      credentials: 'omit',
      cache: 'no-store'
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) { return { status: r.status, j: j || {} }; });
    });
  }
  function ausweis(extra) {
    var a = { kunde: String(K.kunde), ts: String(K.ts), sig: K.sig };
    for (var k in extra) { if (Object.prototype.hasOwnProperty.call(extra, k)) { a[k] = extra[k]; } }
    return a;
  }

  /* Kundensignatur zu alt oder Anmeldung abgelaufen: einmal neu laden, nicht in Schleife. */
  function neuLaden(melde) {
    var k = 'dp_neu';
    var zuletzt = Number(lies(k)) || 0;
    if (Date.now() - zuletzt < 60000) {
      if (melde) { melde('Bitte lade die Seite neu und melde Dich gegebenenfalls noch einmal an.', 'fehler'); }
      return;
    }
    schreib(k, String(Date.now()));
    window.location.reload();
  }

  /* ---------------------------------------------------- Verkaeuferkennung
     REIHENFOLGE absichtlich Zeichen fuer Zeichen wie in mm-partner-content.liquid
     und angebot-feed.liquid:
       1. ?vk=aus / ?vk=off  -> keine Kennung
       2. Geraetespeicher mm_vk (Erst-Klick, 45 Tage ab ts)
       3. ?vk= aus der Adresszeile
       4. sonst nichts
     Der Speicher mm_vk gehoert mm-partner-content; hier wird nur gelesen. */
  var SPEICHER     = 'mm_vk';
  var HALTBAR_TAGE = 45;

  function saeubern(s) {
    if (!s) { return ''; }
    return String(s).trim().toLowerCase().replace(/[^a-z0-9\-]/g, '').slice(0, 60);
  }
  function ausSpeicher() {
    var roh = null;
    try { roh = window.localStorage.getItem(SPEICHER); } catch (e) { return ''; }
    if (!roh) { return ''; }
    if (roh.charAt(0) !== '{') { return saeubern(roh); }
    try {
      var o = JSON.parse(roh);
      if (!o || !o.vk) { return ''; }
      if (o.ts && (Date.now() - o.ts) > HALTBAR_TAGE * 86400000) { return ''; }
      return saeubern(o.vk);
    } catch (e) { return ''; }
  }
  function ausLink() {
    try { return new URLSearchParams(window.location.search).get('vk'); }
    catch (e) { return null; }
  }
  function kennung() {
    var roh = ausLink();
    if (roh !== null) {
      var wort = String(roh).trim().toLowerCase();
      if (wort === 'aus' || wort === 'off') { return ''; }
    }
    return ausSpeicher() || saeubern(roh);
  }

  /* ------------------------------------------------------------- Besitz
     Ein Aufruf je Seite. null = unbekannt (nicht angemeldet, Fehler): dann bleibt alles,
     wie es der Server gerendert hat. */
  var besitzVersprechen = null;
  function besitz(frisch) {
    if (!AKTIV) { return Promise.resolve(null); }
    if (besitzVersprechen && !frisch) { return besitzVersprechen; }
    besitzVersprechen = rufe('premium-bibliothek', ausweis({})).then(function (a) {
      if (a.status === 200 && a.j.ok) {
        var medien = {};
        (a.j.medien || []).forEach(function (x) { if (x && x.m) { medien[x.m] = x; } });
        var angebote = {};
        (a.j.angebote || []).forEach(function (x) { if (x && x.handle) { angebote[x.handle] = x.besitz; } });
        return { medien: medien, angebote: angebote };
      }
      if (a.status === 401) { neuLaden(); }
      return null;
    }).catch(function () { return null; });
    return besitzVersprechen;
  }

  function markiere(wurzel) {
    var marken = (wurzel || document).querySelectorAll('[data-premium-marke]');
    if (!marken.length || !AKTIV) { return Promise.resolve(); }
    return besitz(false).then(function (b) {
      if (!b) { return; }
      Array.prototype.forEach.call(marken, function (el) {
        var h = el.getAttribute('data-premium') || '';
        var ids = (el.getAttribute('data-medien') || '').split(',').filter(Boolean);
        var ganz = b.angebote[h] === 'ganz' ||
          (ids.length > 0 && ids.every(function (m) { return !!b.medien[m]; }));
        if (!ganz) { return; }
        el.setAttribute('data-besitz', 'ja');
        el.setAttribute('title', 'Gekauft');
        var t = el.querySelector('[data-premium-text]');
        if (t) { t.textContent = 'Gekauft'; }
      });
    });
  }

  /* ------------------------------------------------------------- Zugang
     Zwei Uhren: Die Berechtigung gilt fuer immer, die signierte Adresse nur
     Laufzeit + 2 Stunden. */
  var adressen = {};   /* medien (+ "#ton") -> { url, bis, art } */
  /* Liegt eine gültige Adresse schon bereit? Dann geht der Start ohne Anfrage. */
  function bereit(m, ton) {
    var a = adressen[ton ? m + '#ton' : m];
    var jetzt = Math.floor(Date.now() / 1000);
    return (a && a.url && (a.bis - jetzt) > 300) ? a : null;
  }
  function zugang(m, frisch, ton) {
    var k = ton ? m + '#ton' : m;
    var a = frisch ? null : bereit(m, ton);
    if (a) { return Promise.resolve({ status: 200, url: a.url, art: a.art }); }
    var d = { medien: m };
    if (ton) { d.ton = true; }
    return rufe('premium-zugang', ausweis(d)).then(function (r) {
      if (r.status === 200 && r.j.zugang) {
        adressen[k] = { url: r.j.url, bis: Number(r.j.gueltig_bis) || 0, art: r.j.art || '' };
        /* Audio (Datei) ist mit und ohne ton dieselbe Adresse: gleich für beide Schlüssel merken. */
        if (adressen[k].art === 'datei') { adressen[ton ? m : m + '#ton'] = adressen[k]; }
        return { status: 200, url: r.j.url, art: r.j.art || '' };
      }
      return { status: r.status, url: '' };
    }).catch(function () { return { status: 0, url: '' }; });
  }

  function kaufen(variante, handle) {
    var d = { widerruf: true, vk: kennung(), seite: window.location.pathname };
    if (variante) { d.variante = String(variante); }
    if (handle) { d.angebot = String(handle); }
    return rufe('premium-kaufen', ausweis(d));
  }

  /* ------------------------------------------------------------- Stellen (Weiter ab)
     Dieselben Stellen wie Radio und Bibliothek. Gemerkt wird wie im Radio erst ab 10 Minuten Laufzeit;
     gezeigt wird jede gemerkte Stelle (auch eine aus der Bibliothek). */
  var POS_KEY = 'dntk_premium_pos';
  var POS_LANG = 600;
  function stellen() {
    try { return JSON.parse(window.localStorage.getItem(POS_KEY) || '{}') || {}; } catch (e) { return {}; }
  }
  /* Am Anfang (unter 15 s) nichts ändern: Hat das Weiterspielen an der Stelle auf einem Gerät nicht
     gegriffen, bleibt die alte Stelle erhalten. Kurz vor dem Ende: gelöscht (zu Ende gehört). */
  function merkeStelle(m, sek, laenge) {
    if (!m || !(laenge > POS_LANG) || !sek || sek < 15) { return; }
    try {
      var p = stellen();
      if (sek > laenge - 30) { delete p[m]; }
      else { p[m] = { p: Math.floor(sek), d: Math.floor(laenge), t: Date.now() }; }
      window.localStorage.setItem(POS_KEY, JSON.stringify(p));
    } catch (e) {}
  }
  function loescheStelle(m) {
    try {
      var p = stellen();
      if (!m || !p[m]) { return; }
      delete p[m];
      window.localStorage.setItem(POS_KEY, JSON.stringify(p));
    } catch (e) {}
  }
  function stelle(m) {
    var x = m ? stellen()[m] : null;
    return (x && x.p > 15) ? x : null;
  }
  function stellenZeit(s) {
    s = Math.max(0, Math.floor(Number(s) || 0));
    var h = Math.floor(s / 3600), mi = Math.floor((s % 3600) / 60), se = s % 60;
    return (h ? h + ':' + (mi < 10 ? '0' : '') + mi : String(mi)) + ':' + (se < 10 ? '0' : '') + se;
  }

  /* ------------------------------------------------------------- Dauerton
     Wie im Radio: Ein stiller Ton in Schleife hält die Seite im Hintergrund wach, solange eine Karte
     spielt. Zwischen zwei Titeln spielt sonst kurz nichts, und das Handy legt die Seite schlafen. */
  var STILL = 'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YQQAAAAAAA==';
  var eigeneMedien = [];   /* Video-Elemente und Tonspieler der Angebotskarten */
  var dauerton = null;
  function wach(an) {
    try {
      if (!dauerton) {
        if (!an || typeof Audio !== 'function') { return; }
        dauerton = new Audio(STILL);
        dauerton.loop = true;
      }
      if (an) {
        var p = dauerton.play();
        if (p && typeof p.catch === 'function') { p.catch(function () {}); }
      } else {
        dauerton.pause();
      }
    } catch (e) {}
  }
  /* Spielt nach einer Pause oder am Ende keine Karte mehr, geht auch der Dauerton aus. */
  function wachPruefen() {
    setTimeout(function () {
      var spielt = eigeneMedien.some(function (el) { return !el.paused && !el.ended; });
      if (!spielt) { wach(false); }
    }, 5000);
  }
  /* Freie Vorschauen schließen (das Karten-Band der Section kennt nur Videos, keinen Tonspieler). */
  function schliesseVorschauen() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-dp-vorschau-ebene]'), function (e) {
      if (e.hidden) { return; }
      e.innerHTML = '';
      e.hidden = true;
      var k = e.closest ? e.closest('.dp__karte') : null;
      if (k && typeof k.dpAktualisiere === 'function') { k.dpAktualisiere(); }
    });
  }

  /* ------------------------------------------------------------- Player
     Antwortet nginx mit 410 (abgelaufen) oder 403, wird still eine neue Adresse geholt
     und an derselben Stelle weitergespielt. */
  function ladeHls() {
    if (window.Hls) { return Promise.resolve(window.Hls); }
    return new Promise(function (ok, nein) {
      var s = document.createElement('script');
      s.src = HLS_SRC;
      s.async = true;
      s.onload = function () { if (window.Hls) { ok(window.Hls); } else { nein(new Error('hls.js fehlt')); } };
      s.onerror = function () { nein(new Error('hls.js nicht geladen')); };
      document.head.appendChild(s);
    });
  }

  function neuerPlayer(video, h) {
    h = h || {};
    var melde = h.melde || function () {};
    var hls = null;
    var aktuell = null;
    var art = '';          /* laufende Adresse: 'hls' (Video), 'datei' (Audio), 'ton' (Tondatei eines Videos) */
    var letzteErneuerung = 0;
    var lauf = 0;          /* zählt die Starts: Nachzügler eines älteren Starts tun nichts mehr */
    var offen = false;     /* Tonspieler wurde schon einmal durch einen Fingertipp gestartet (iOS) */
    var angehalten = false; /* seit dem letzten Start hat jemand den Tonspieler angehalten */

    /* Tonspieler der Karte: Audio-Dateien und Tondateien von Videos laufen wie im Radio in einem
       <audio>-Element. Er liegt im Medienfeld über dem Cover; das <video> zeigt nur Videos mit Bild. */
    var audio = document.createElement('audio');
    audio.preload = 'auto';
    audio.controls = true;
    audio.hidden = true;
    audio.setAttribute('playsinline', '');
    audio.setAttribute('controlslist', 'nodownload');
    audio.setAttribute('data-dp-audio', '');
    audio.setAttribute('aria-label', 'Wiedergabe');
    if (audio.style) {
      audio.style.cssText = 'position:absolute;left:8px;right:8px;bottom:8px;width:calc(100% - 16px);height:40px;z-index:1;color-scheme:dark;';
    }
    var box = video.parentNode;
    if (box) {
      if (box.insertBefore) { box.insertBefore(audio, video.nextSibling || null); }
      else if (box.appendChild) { box.appendChild(audio); }
    }

    function stille() { return String(audio.getAttribute('src') || '').indexOf('data:') === 0; }
    function medium() { return (art === 'datei' || art === 'ton') ? audio : video; }
    var cover = '';        /* Cover des laufenden Titels: Hintergrund nur hinter dem Tonspieler, nie hinter einem Video */
    function zeige(ton) {
      audio.hidden = !ton;
      video.hidden = !!ton;
      if (h.lage) { try { h.lage(!!ton); } catch (e) {} }
      if (box && box.style) {
        box.style.backgroundImage = (ton && cover) ? 'url("' + cover.replace(/"/g, '%22') + '")' : '';
        box.style.backgroundSize = 'contain';
        box.style.backgroundPosition = 'center';
        box.style.backgroundRepeat = 'no-repeat';
      }
    }
    audio.addEventListener('playing', function () { if (!stille()) { offen = true; } });
    audio.addEventListener('pause', function () { if (audio.paused && !stille()) { angehalten = true; } });

    /* iOS erlaubt play() nur im Fingertipp. Deshalb den Tonspieler beim ersten Tipp einmal mit Stille
       starten; danach darf er auch im Hintergrund von selbst weiterspielen (wie im Radio). */
    function entsperre() {
      if (offen || !audio.paused) { return; }
      try {
        audio.src = STILL;
        var p = audio.play();
        if (p && typeof p.then === 'function') { p.then(function () { offen = true; }, function () {}); }
      } catch (e) {}
    }

    function adresse(m, frisch, ton) {
      return zugang(m, frisch, ton).then(function (r) {
        if (r.status === 200) { return r; }
        if (r.status === 401) { neuLaden(melde); }
        if (r.status === 403 && h.gesperrt) { h.gesperrt(m); }
        if (r.status === 409 && h.bald) { h.bald(m); }
        throw new Error('kein Zugang (' + r.status + ')');
      });
    }

    function stoppeVideo() {
      if (hls) { try { hls.destroy(); } catch (e) {} hls = null; }
      try { video.pause(); } catch (e) {}
      video.removeAttribute('src');
      try { video.load(); } catch (e) {}
    }
    function stoppe() {
      try { audio.pause(); } catch (e) {}
      stoppeVideo();
    }

    function abspielen(el) {
      var p = el.play();
      if (p && typeof p.catch === 'function') { p.catch(function () { /* Autoplay gesperrt: Nutzer drueckt selbst */ }); }
    }

    function starte(url, ab, sofort) {
      var meiner = ++lauf;
      if (!/\.m3u8(\?|$)/i.test(url)) {
        /* Premium-Audio und Tondateien: signierte Einzeldatei im Tonspieler. Neue Adresse setzen und
           sofort abspielen, ohne Zwischenhalt und ohne auf die Datei zu warten; nach 50 ms noch einmal
           anstoßen (wie im Radio), falls der erste Start nicht gegriffen hat. */
        if (hls || video.getAttribute('src')) { stoppeVideo(); }
        zeige(true);
        ab = Number(ab) || 0;
        audio.addEventListener('loadedmetadata', function () {
          if (meiner !== lauf) { return; }
          if (ab > 0 && Math.abs((Number(audio.currentTime) || 0) - ab) > 2) { try { audio.currentTime = ab; } catch (e) {} }
        }, { once: true });
        audio.src = url + (ab > 1 ? '#t=' + ab.toFixed(1) : '');
        try { audio.load(); } catch (e) {}
        angehalten = false;
        if (sofort) {
          /* 2026-10-25: Radio gleich hier anhalten. Bisher geschah das nur im play-Ereignis des Tonspielers, und das
             kommt in der Android-App (WebToApp) offenbar nicht an: Radio und Ton liefen dort parallel. */
          radioAnhalten(audio);
          abspielen(audio);
          /* Nicht noch einmal anstoßen, wenn inzwischen jemand angehalten hat (andere Karte, Radio, Nutzer). */
          setTimeout(function () { if (meiner === lauf && audio.paused && !angehalten) { abspielen(audio); } }, 50);
        }
        return Promise.resolve();
      }
      /* Video mit Bild: HLS im <video>. */
      try { if (!audio.paused) { audio.pause(); } } catch (e) {}
      zeige(false);
      stoppeVideo();
      return ladeHls().then(function (Hls) {
        if (!Hls.isSupported()) { throw new Error('kein MSE'); }
        hls = new Hls({ startPosition: ab > 0 ? ab : -1 });
        hls.on(Hls.Events.MANIFEST_PARSED, function () { if (sofort) { abspielen(video); } });
        hls.on(Hls.Events.ERROR, function (ev, d) {
          var code = d && d.response ? d.response.code : 0;
          if (code === 410 || code === 403) { erneuere(); return; }
          if (!d || !d.fatal) { return; }
          if (d.type === Hls.ErrorTypes.NETWORK_ERROR) { hls.startLoad(); return; }
          if (d.type === Hls.ErrorTypes.MEDIA_ERROR) { hls.recoverMediaError(); return; }
          melde('Die Wiedergabe wurde unterbrochen. Bitte starte die Folge noch einmal.', 'fehler');
        });
        hls.loadSource(url);
        hls.attachMedia(video);
      }).catch(function () {
        /* Safari/iOS ohne MediaSource: HLS kann das Video-Element selbst. */
        if (video.canPlayType('application/vnd.apple.mpegurl')) {
          video.src = url;
          video.addEventListener('loadedmetadata', function () {
            if (ab > 0) { try { video.currentTime = ab; } catch (e) {} }
            if (sofort) { abspielen(video); }
          }, { once: true });
          return;
        }
        melde('Dein Browser kann diese Folge leider nicht abspielen.', 'fehler');
      });
    }

    function erneuere() {
      if (!aktuell) { return; }
      if (Date.now() - letzteErneuerung < 20000) { return; }
      letzteErneuerung = Date.now();
      var v = medium();
      var pos = v.currentTime || 0;
      var lief = !v.paused;
      adresse(aktuell, true, art === 'ton').then(function (r) {
        art = r.art || art;
        return starte(r.url, pos, lief);
      }).catch(function () {
        melde('Die Freigabe ließ sich nicht erneuern. Bitte lade die Seite neu.', 'fehler');
      });
    }

    video.addEventListener('error', function () {
      if (!hls && aktuell && video.getAttribute('src')) { erneuere(); }
    });
    audio.addEventListener('error', function () {
      if (aktuell && medium() === audio && audio.getAttribute('src') && !stille()) { erneuere(); }
    });

    function spiele(m, info, sofort) {
      aktuell = m;
      info = info || {};
      if (info.poster) { video.setAttribute('poster', info.poster); } else { video.removeAttribute('poster'); }
      cover = String(info.poster || '');   /* zeige() legt es hinter den Tonspieler; bei Videos mit Bild bleibt der Hintergrund schwarz */
      /* Liegt die Adresse schon bereit (vorgeholt), geht es im selben Augenblick los. */
      var fertig = bereit(m, !!info.ton);
      /* Startet nicht ohnehin gleich der Tonspieler, ihn im Fingertipp mit Stille freischalten. */
      if (sofort && !(fertig && fertig.art !== 'hls')) { entsperre(); }
      if (fertig) {
        art = fertig.art || '';
        if (art === 'hls') { zugang(m, false, true); }
        try { return Promise.resolve(starte(fertig.url, info.ab || 0, sofort)); } catch (e) { return Promise.reject(e); }
      }
      return adresse(m, false, !!info.ton).then(function (r) {
        art = r.art || '';
        /* Etappe 5d: Tondatei eines Videos gleich mitholen, damit der Wechsel im Hintergrund ohne Warten geht */
        if (art === 'hls') { zugang(m, false, true); }
        return starte(r.url, info.ab || 0, sofort);
      });
    }

    /* Etappe 5d: Video -> Tondatei an derselben Stelle (ohne Netz, die Adresse liegt schon bereit). */
    function tonAdresse() {
      if (!aktuell) { return ''; }
      var a = adressen[aktuell + '#ton'];
      var jetzt = Math.floor(Date.now() / 1000);
      return (a && a.url && a.art === 'ton' && (a.bis - jetzt) > 60) ? a.url : '';
    }
    function alsTon(laufen) {
      if (art !== 'hls') { return false; }
      var url = tonAdresse();
      if (!url) { return false; }
      var ab = Number(video.currentTime) || 0;
      art = 'ton';
      starte(url, ab, laufen);
      return true;
    }
    /* Zurück auf der Seite: wieder mit Bild an derselben Stelle. */
    function mitBild(laufen) {
      if (art !== 'ton' || !aktuell) { return Promise.resolve(false); }
      var m = aktuell;
      return adresse(m, false, false).then(function (r) {
        if (art !== 'ton' || aktuell !== m) { return false; }
        var ab = Number(audio.currentTime) || 0;
        art = r.art || '';
        return Promise.resolve(starte(r.url, ab, laufen)).then(function () { return true; });
      }).catch(function () { return false; });
    }

    return { spiele: spiele, stoppe: stoppe, alsTon: alsTon, mitBild: mitBild, art: function () { return art; },
             medium: medium, audio: audio };
  }

  /* ------------------------------------------------ Sperrbildschirm (Media Session)
     Eine Karte zur Zeit hat die Bedienung. Das Radio (<audio id="main-player">, globale Funktionen
     togglePlay und setupMediaHandlers) wird nur über seine eigenen Funktionen angefasst. */
  var MS = ('mediaSession' in navigator) ? navigator.mediaSession : null;
  var MS_AKTIONEN = ['play', 'pause', 'stop', 'previoustrack', 'nexttrack', 'seekbackward', 'seekforward', 'seekto'];
  var sitzung = null;      /* { video, meta, anhalten } der Karte, die gerade die Bedienung hat */
  var fremdeMeta = null;   /* Metadaten, die vorher galten (Radio), zum Zurückgeben */

  function msAktion(aktion, f) {
    if (!MS) { return; }
    try { MS.setActionHandler(aktion, f); } catch (e) { /* Aktion vom Gerät nicht unterstützt */ }
  }
  function radioAnhalten(ausser) {
    var r = document.getElementById('main-player');
    if (!r || r === ausser || r.paused || typeof window.togglePlay !== 'function') { return; }
    try { window.togglePlay(); } catch (e) {}
  }
  function gibBedienungAb() {
    var s = sitzung;
    if (!s) { return; }
    sitzung = null;
    try { if (s.anhalten) { s.anhalten(); } else if (!s.video.paused) { s.video.pause(); } } catch (e) {}
    if (!MS) { return; }
    MS_AKTIONEN.forEach(function (a) { msAktion(a, null); });
    try { if (MS.metadata === s.meta) { MS.metadata = fremdeMeta; } } catch (e) {}
    fremdeMeta = null;
    if (typeof window.setupMediaHandlers === 'function') { try { window.setupMediaHandlers(); } catch (e) {} }
  }
  /* Startet ein anderes Medium (Radio, PLUS-Video im Radio), gibt die Karte ab. */
  document.addEventListener('play', function (e) {
    var el = e.target;
    if (!el || !(el instanceof HTMLMediaElement) || eigeneMedien.indexOf(el) !== -1) { return; }
    if (sitzung && el !== sitzung.video) { gibBedienungAb(); }
    /* 2026-10-25: auch ohne Sitzung (die entsteht im play-Ereignis des Tonspielers, das in der Android-App fehlen kann)
       jeden Spieler der Karten anhalten, sobald etwas anderes hörbar startet. Stilles, Stummes und Schleifen zählen nicht. */
    if (el.muted || el.loop || String(el.getAttribute('src') || '').indexOf('data:') === 0) { return; }
    eigeneMedien.forEach(function (x) { try { if (!x.paused) { x.pause(); } } catch (err) {} });
  }, true);

  function coverAdresse(url, breite) {
    url = String(url || '');
    if (!url) { return ''; }
    if (url.indexOf('//') === 0) { url = 'https:' + url; }
    if (/[?&]width=\d+/.test(url)) { return url.replace(/([?&]width=)\d+/, '$1' + breite); }
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + breite;
  }

  /* ------------------------------------------------ Section dntk-premium-angebot */
  function bindeAngebot(root) {
    if (!root || root.getAttribute('data-dp-bereit') === '1') { return; }
    root.setAttribute('data-dp-bereit', '1');

    var C;
    try { C = JSON.parse(root.querySelector('[data-dp-angebot]').textContent); } catch (e) { return; }

    function q(sel) { return root.querySelector(sel); }
    var statusEl     = q('[data-dp-status]');
    var kaufbox      = q('[data-dp-kaufbox]');
    var kaufbereich  = q('[data-dp-kaufbereich]');
    var aufladenBox  = q('[data-dp-aufladenbereich]');
    var fehltEl      = q('[data-dp-fehlt]');
    var stufenBox    = q('[data-dp-stufen]');
    var guthabenEl   = q('[data-dp-guthaben]');
    var haken        = q('[data-dp-haken]');
    var knopf        = q('[data-dp-kaufen]');
    var neuKnopf     = q('[data-dp-neu]');
    var fertigEl     = q('[data-dp-fertig]');
    var pauseEl      = q('[data-dp-pause]');
    var playerBox    = q('[data-dp-player]');
    var video        = q('[data-dp-video]');
    var jetztEl      = q('[data-dp-jetzt]');

    function melde(text, art) {
      if (!statusEl) { return; }
      statusEl.textContent = text || '';
      statusEl.setAttribute('data-art', art || '');
      statusEl.hidden = !text;
    }

    if (!K.angemeldet) { return; }      /* Anmelden-Knopf rendert der Server, sonst nichts */
    if (!AKTIV) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-dp-label]'), function (l) { l.textContent = 'PLUS'; });
      if (kaufbox) { kaufbox.hidden = true; }
      melde('Der Verkauf ist gerade noch nicht eingerichtet. Bitte versuche es später noch einmal.', 'hinweis');
      return;
    }

    var FLAG_AUFLADEN = 'dp_aufladen_' + C.sid;
    var folgen = (C.folgen || []).filter(function (f) { return f && f.m; });
    var zeilen = {};
    Array.prototype.forEach.call(root.querySelectorAll('[data-dp-folge]'), function (z) {
      zeilen[z.getAttribute('data-dp-folge')] = z;
    });

    function setzeZeile(m, zustand) {
      var z = zeilen[m];
      if (!z) { return; }
      z.setAttribute('data-zustand', zustand);
      var b = z.querySelector('[data-dp-spielen]');
      var l = z.querySelector('[data-dp-label]');
      if (b) { b.disabled = zustand !== 'frei'; }
      if (l) {
        l.textContent = zustand === 'frei' ? 'Abspielen'
                      : zustand === 'bald' ? 'Wird eingerichtet'
                      : 'PLUS';
      }
      beschrifte(m, zustand);
      if (typeof tastenStand === 'function') { tastenStand(); }   /* wird ein Titel frei, „Titel vor“ nachziehen */
      deckelText();
    }
    /* Weiter ab: Knopf eines freigeschalteten Titels mit gemerkter Stelle heißt „Weiter ab 20:09“. */
    function beschrifte(m, zustand) {
      var z = zeilen[m];
      if (!z) { return; }
      var st = zustand === 'frei' ? stelle(m) : null;
      var l = z.querySelector('[data-dp-label]');
      if (l && zustand === 'frei') { l.textContent = st ? 'Weiter ab ' + stellenZeit(st.p) : 'Abspielen'; }
      zeigeBalken(m, st);
    }
    /* Weiter ab: dünner Balken unter dem Titel, wie weit er gehört ist. */
    function zeigeBalken(m, st) {
      var z = zeilen[m];
      if (!z) { return; }
      var text = z.querySelector('.dp__folge-text');
      var b = z.querySelector('[data-dp-stand]');
      var d = st ? Number(st.d) || 0 : 0;
      if (st && d > 0 && text && text.appendChild) {
        if (!b) {
          b = document.createElement('span');
          b.setAttribute('data-dp-stand', '');
          if (b.style) { b.style.cssText = 'display:block;max-width:14rem;height:3px;margin-top:.4rem;border-radius:2px;overflow:hidden;background:rgba(var(--color-foreground),.14);'; }
          var f = document.createElement('span');
          if (f.style) { f.style.cssText = 'display:block;height:100%;width:0;background:rgb(var(--dp-akzent,205,0,57));'; }
          b.appendChild(f);
          text.appendChild(b);
        }
        var fuellung = b.firstChild || (b.children && b.children[0]);
        if (fuellung && fuellung.style) { fuellung.style.width = Math.min(100, Math.round(st.p / d * 100)) + '%'; }
      } else if (b && b.parentNode && b.parentNode.removeChild) {
        b.parentNode.removeChild(b);
      }
    }
    function zeigeStellen() {
      folgen.forEach(function (f) {
        var z = zeilen[f.m];
        if (z && z.getAttribute('data-zustand') === 'frei') { beschrifte(f.m, 'frei'); }
      });
      deckelText();
    }
    /* Knopf im Cover: Die Section schreibt dort „Abspielen“ und spielt den ersten freigeschalteten Titel.
       Gibt es in der Karte einen Titel mit gemerkter Stelle, heißt der Knopf „Weiter ab …“ und spielt den
       zuletzt gehörten dieser Titel an seiner Stelle weiter (wie im Radio). */
    var startKnopf = q('.dp__start[data-dp-start]');
    var startText = startKnopf ? startKnopf.querySelector('[data-dp-start-text]') : null;
    function zuletztGehoert() {
      var p = stellen();
      var best = null;
      folgen.forEach(function (f) {
        var x = p[f.m];
        var z = zeilen[f.m];
        if (!x || !(x.p > 15) || !z || z.getAttribute('data-zustand') !== 'frei') { return; }
        if (!best || (Number(x.t) || 0) > best.t) { best = { m: f.m, t: Number(x.t) || 0 }; }
      });
      return best ? best.m : null;
    }
    function deckelText() {
      if (!startText) { return; }
      var t = String(startText.textContent || '');
      if (t !== 'Abspielen' && t.indexOf('Weiter ab ') !== 0) { return; }
      var m = zuletztGehoert();
      var st = m ? stelle(m) : null;
      var soll = st ? 'Weiter ab ' + stellenZeit(st.p) : 'Abspielen';
      if (t !== soll) { startText.textContent = soll; }
    }
    if (startText && window.MutationObserver) {
      try { new MutationObserver(deckelText).observe(startText, { childList: true, characterData: true, subtree: true }); } catch (e) {}
    }
    /* Klick auf den Cover-Knopf mit gemerkter Stelle: die Engine startet den zuletzt gehörten Titel (vor der
       Section, die sonst den ersten freigeschalteten startet). Ohne gemerkte Stelle bleibt alles wie bisher. */
    if (startKnopf && root.addEventListener) {
      root.addEventListener('click', function (e) {
        var s = e.target && e.target.closest ? e.target.closest('.dp__start[data-dp-start]') : null;
        if (s !== startKnopf || !player) { return; }
        var t = startText ? String(startText.textContent || '') : '';
        if (t.indexOf('Weiter ab ') !== 0) { return; }
        var m = zuletztGehoert();
        if (!m) { return; }
        e.stopPropagation();
        spiele(m, true);
      }, true);
    }

    var tastenLage = function () {};   /* wird weiter unten gesetzt, sobald es die Titel-Tasten gibt */
    var player = video ? neuerPlayer(video, {
      melde: melde,
      gesperrt: function (m) { setzeZeile(m, 'gesperrt'); },
      bald: function (m) { setzeZeile(m, 'bald'); },
      lage: function (ton) { ruheBis = Date.now() + 4000; tastenLage(ton); }   /* jeder Start oder Wechsel: kurz nicht merken */
    }) : null;

    /* Beide Spieler der Karte (Video mit Bild, Tonspieler). Die Stille zum Freischalten zählt nicht. */
    var medien = player ? [video, player.audio] : [];
    medien.forEach(function (el) { eigeneMedien.push(el); });
    var M = function () { return player ? player.medium() : video; };
    function hoere(ereignis, fn) {
      medien.forEach(function (el) {
        el.addEventListener(ereignis, function (e) {
          if (el !== video && String(el.getAttribute('src') || '').indexOf('data:') === 0) { return; }
          fn(el, e);
        });
      });
    }
    var anhalten = function () {
      medien.forEach(function (el) { try { if (!el.paused) { el.pause(); } } catch (e) {} });
    };

    /* Weiter ab: Stelle des laufenden Titels merken. Nicht in den ersten 4 s nach einem Start (dann steht
       das Element oft noch am Anfang oder beim alten Titel). */
    var ruheBis = 0;
    var zuletztGemerkt = 0;
    function sichere(jetzt) {
      if (!player || !aktuellM || Date.now() < ruheBis) { return; }
      var el = M();
      if (el !== video && String(el.getAttribute('src') || '').indexOf('data:') === 0) { return; }
      var d = Number(el.duration);
      var t = Number(el.currentTime) || 0;
      if (!isFinite(d) || d <= 0 || t <= 0) { return; }
      if (!jetzt && Date.now() - zuletztGemerkt < 5000) { return; }
      zuletztGemerkt = Date.now();
      merkeStelle(aktuellM, t, d);
    }
    if (player) {
      hoere('timeupdate', function (el) { if (el === M()) { sichere(false); } });
      hoere('pause', function (el) { if (el === M()) { sichere(true); zeigeStellen(); } });
      if (window.addEventListener) { window.addEventListener('pagehide', function () { sichere(true); }); }
    }
    var wunschTon = false;   /* der Hörer hat „Nur Ton“ gewählt (gilt für die Karte) */
    var keinTon = {};        /* Titel ohne Tondatei */

    /* Album und Paket: Ist ein Titel zu Ende, spielt der naechste freigeschaltete weiter. */
    function naechsteFreie() {
      var jetzt = -1;
      for (var i = 0; i < folgen.length; i++) {
        if (zeilen[folgen[i].m] && zeilen[folgen[i].m].getAttribute('data-aktiv') === '1') { jetzt = i; break; }
      }
      if (jetzt < 0) { return null; }
      for (var j = jetzt + 1; j < folgen.length; j++) {
        var z = zeilen[folgen[j].m];
        if (z && z.getAttribute('data-zustand') === 'frei') { return folgen[j].m; }
      }
      return null;
    }
    /* Rundlauf: Nach dem letzten freigeschalteten Titel eines Albums geht es beim ersten weiter.
       Die Musik hört nicht von selbst auf. Einzelfolgen laufen einmal durch. */
    function naechsterImRundlauf() {
      var n = naechsteFreie();
      if (n || folgen.length < 2 || !aktuellM) { return n; }
      return ersteFreie();
    }
    /* Adresse des nächsten Titels vorholen, solange der laufende spielt: Der Wechsel am Ende braucht
       dann keine Anfrage. Videos: zusätzlich die Tondatei (für den Wechsel im Hintergrund). */
    var vorholenLaeuft = '';
    var vorholenFehler = {};   /* medien -> Zeitpunkt des letzten Fehlversuchs (nicht im Sekundentakt nachfragen) */
    function holeNaechsten() {
      var n = naechsterImRundlauf();
      if (!n || vorholenLaeuft === n || (bereit(n, false) && bereit(n, true))) { return; }
      if (vorholenFehler[n] && Date.now() - vorholenFehler[n] < 30000) { return; }
      vorholenLaeuft = n;
      var fertig = function () { if (vorholenLaeuft === n) { vorholenLaeuft = ''; } };
      zugang(n, false, false).then(function (r) {
        if (r.status !== 200) { vorholenFehler[n] = Date.now(); return null; }
        delete vorholenFehler[n];
        return r.art === 'hls' ? zugang(n, false, true) : null;
      }).then(fertig, fertig);
    }
    var wechsel = 0;   /* Zeitpunkt des letzten Titelwechsels (gegen doppeltes Weiterschalten) */
    function zumNaechsten() {
      var n = naechsterImRundlauf();
      if (!n) { return false; }
      wechsel = Date.now();
      loescheStelle(aktuellM);   /* zu Ende gehört */
      zeigeStellen();
      aktuellM = null;           /* nicht noch einmal unter dem alten Titel merken */
      spiele(n, true);
      return true;
    }
    if (video && player && folgen.length > 1) {
      /* Rückfall: Der Titel ist wirklich zu Ende (Video mit Bild, oder der Wechsel davor hat nicht gegriffen). */
      hoere('ended', function () {
        if (Date.now() - wechsel < 1500) { return; }
        zumNaechsten();
      });
      hoere('playing', function () { holeNaechsten(); });
      var vorholenZuletzt = 0;
      hoere('timeupdate', function (el) {
        if (el !== M()) { return; }
        var d = Number(el.duration);
        var t = Number(el.currentTime) || 0;
        if (!isFinite(d) || d <= 0) { return; }
        /* Wie im Radio: eine halbe Sekunde vor dem Ende wechseln, solange der Titel noch spielt.
           Dann reißt der Ton im Hintergrund nicht ab. t > 2: Manche Geräte melden nach einem Wechsel
           kurz noch die Länge des vorigen Titels. Nur im Tonspieler; Videos mit Bild laufen bis zum Ende. */
        if (el === player.audio && !el.paused && t > 2 && t > d - 0.5 && Date.now() - wechsel > 3000) {
          if (zumNaechsten()) { return; }
        }
        /* Kurz vor dem Ende noch einmal nachsehen (Adresse abgelaufen oder Vorholen fehlgeschlagen). */
        if (d - t > 45) { return; }
        var jetzt = Date.now();
        if (jetzt - vorholenZuletzt < 5000) { return; }
        vorholenZuletzt = jetzt;
        holeNaechsten();
      });
    }
    if (video && player) {
      /* Dauerton an, solange die Karte spielt. Nur eine Quelle spielt: andere Karten anhalten,
         Vorschauen schließen (das Karten-Band der Section kennt nur Videos). */
      hoere('play', function (el) {
        wach(true);
        eigeneMedien.forEach(function (x) {
          if (medien.indexOf(x) === -1) { try { if (!x.paused) { x.pause(); } } catch (e) {} }
        });
        if (el === player.audio) { schliesseVorschauen(); }
      });
      hoere('pause', function () { wachPruefen(); });
      hoere('ended', function () { wachPruefen(); });
      /* Startet jemand eine freie Vorschau (in einer Karte ohne Freischaltung), hält der Tonspieler an. */
      document.addEventListener('click', function (e) {
        var s = e.target && e.target.closest ? e.target.closest('[data-dp-start]') : null;
        if (!s || player.audio.paused) { return; }
        var k = s.closest('[data-dntk-premium-angebot]');
        if (k === root || (k && k.querySelector('[data-dp-folge][data-zustand="frei"]'))) { return; }
        player.audio.pause();
      }, true);
    }

    /* Etappe 5d: Verschwindet die Seite, während ein Video spielt, geht es als Ton weiter; zurück mit Bild. */
    var imHintergrund = function () { return document.visibilityState === 'hidden'; };
    var zuTon = function (laufen) {
      if (!player || player.art() !== 'hls') { return false; }
      if (document.pictureInPictureElement === video || (video && video.webkitPresentationMode === 'picture-in-picture')) { return false; }
      return player.alsTon(laufen);
    };
    if (video && player) {
      document.addEventListener('visibilitychange', function () {
        if (imHintergrund()) {
          sichere(true);
          if (player.art() === 'hls' && !video.paused) { zuTon(true); }
        } else if (player.art() === 'ton' && !wunschTon) {
          player.mitBild(!player.audio.paused);
        }
      });
      video.addEventListener('pause', function () {
        /* Das Handy hält das Video an, weil die Seite verschwunden ist (nicht die Hand des Nutzers):
           als Ton weiter. Hat ein anderes Medium die Bedienung übernommen, bleibt die Karte still. */
        if (!imHintergrund() || player.art() !== 'hls') { return; }
        if (MS && (!sitzung || sitzung.video !== video)) { return; }
        zuTon(true);
      });
    }

    var aktuellM = null;

    /* Bedienung in der Zeile unter dem Medienfeld (.dp__kopf), links neben „Teilen“:
       „Titel zurück“ (Album, Staffel), Abspielen/Pause, „Titel vor“ (Album, Staffel) und die Zeit.
       Sie erscheint mit dem ersten Abspielen und steht dann an der Stelle der kleinen Zeile
       „DNTK-PLUS · DNTK Records“. Der Tonspieler hat dafür keine eigene Leiste mehr: über dem Cover liegt
       nichts. Im Spalt zwischen Medienfeld und Zeile liegt eine dünne Fortschrittslinie (Antippen, Ziehen).
       Die Titel-Tasten tun dasselbe wie die Tasten im Sperrbildschirm: „zurück“ springt nach mehr als
       3 Sekunden an den Anfang des Titels, sonst zum vorigen; „vor“ zum nächsten freigeschalteten Titel,
       am letzten zum ersten (Rundlauf).
       Rückfall für eine Section ohne diese Zeile: Leiste des Tonspielers wie bisher, Titel-Tasten rund im
       Medienfeld (Tonspieler: über der schmalen Leiste, Video mit Bild: auf halber Höhe). */
    var tastenStand = function () {};
    var tastenZeigen = function () {};
    var umschaltStand = function () {};
    var umschaltZeichen = function () {};
    var umschalt = null;
    var umschaltFeld = null;
    var kopf = q('.dp__kopf');
    var inZeile = !!(kopf && kopf.insertBefore);
    var album = folgen.length > 1;
    if (video && player && playerBox && (inZeile || album)) {
      var freierNachbar = function (schritt) {
        var frei = folgen.filter(function (f) { return zeilen[f.m] && zeilen[f.m].getAttribute('data-zustand') === 'frei'; });
        for (var i = 0; i < frei.length; i++) {
          /* Rundlauf: „vor“ am letzten Titel führt zum ersten (nicht, wenn nur ein Titel frei ist). */
          if (frei[i].m === aktuellM) { return frei[i + schritt] || (schritt > 0 && frei.length > 1 ? frei[0] : null); }
        }
        return null;
      };
      var tastenBox = null;
      if (inZeile) {
        tastenBox = document.createElement('span');
        tastenBox.setAttribute('data-dp-titel-tasten', '');
        /* margin -4px: Die Tippfläche (34 px) ist höher als die Zeile (26 px), die Zeile behält ihre Höhe. */
        if (tastenBox.style) { tastenBox.style.cssText = 'display:none;align-items:center;gap:6px;margin:-4px 0;flex:1 1 auto;min-width:0;'; }
        kopf.insertBefore(tastenBox, kopf.firstChild || null);
      }
      /* In der Zeile: Die Taste selbst ist die unsichtbare Tippfläche (46 × 34 px, auf schmalen Handys bis
         34 px schmal); sichtbar ist ein flaches Feld mit abgerundeten Ecken darin (26 px hoch, wie „Teilen“).
         Abspielen/Pause ist gefüllt, die Titel-Tasten haben nur einen Rand. */
      var FELD = 'display:flex;align-items:center;justify-content:center;width:100%;height:26px;box-sizing:border-box;' +
        'border-radius:8px;pointer-events:none;';
      var RAND = 'border:1px solid rgba(var(--color-foreground),.35);';
      var VOLL = 'border:1px solid rgb(var(--color-foreground));background:rgb(var(--color-foreground));color:rgb(var(--color-background,18,18,18));';
      var TASTE = inZeile
        ? 'width:46px;height:34px;min-width:34px;margin:0;padding:0;display:inline-flex;align-items:center;justify-content:center;flex:0 1 46px;' +
          'border:0;background:transparent;color:rgb(var(--color-foreground));cursor:pointer;' +
          '-webkit-tap-highlight-color:transparent;touch-action:manipulation;'
        : 'position:absolute;z-index:2;width:40px;height:40px;margin:0;padding:0;display:flex;align-items:center;justify-content:center;' +
          'border-radius:999px;border:1px solid rgba(255,255,255,.35);background:rgba(0,0,0,.5);color:#fff;cursor:pointer;' +
          '-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);-webkit-tap-highlight-color:transparent;touch-action:manipulation;';
      var zeichen = function (pfad) {
        var g = inZeile ? 18 : 22;
        return '<svg viewBox="0 0 24 24" width="' + g + '" height="' + g + '" aria-hidden="true" focusable="false" style="fill:currentColor;display:block"><path d="' + pfad + '"/></svg>';
      };
      var felder = {};   /* sichtbares Feld je Taste (nur in der Zeile) */
      var baueTaste = function (kennung, name, pfad, seite, voll) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute(kennung, '');
        b.setAttribute('aria-label', name);
        b.setAttribute('title', name);
        if (inZeile) {
          var feld = document.createElement('span');
          if (feld.style) { feld.style.cssText = FELD + (voll ? VOLL : RAND); }
          feld.innerHTML = zeichen(pfad);
          b.appendChild(feld);
          felder[kennung] = feld;
          if (b.style) { b.style.cssText = TASTE; }
          tastenBox.appendChild(b);
        } else {
          b.innerHTML = zeichen(pfad);
          if (b.style) { b.style.cssText = TASTE + seite + ':8px;bottom:56px;'; }
          playerBox.appendChild(b);
        }
        return b;
      };
      var P_SPIEL = 'M8 5v14l11-7z';
      var P_PAUSE = 'M6 5h4v14H6zm8 0h4v14h-4z';
      var tasteZurueck = album ? baueTaste('data-dp-titel-zurueck', 'Titel zurück', 'M6 6h2v12H6zm3.5 6 8.5 6V6z', 'left', false) : null;
      var tasteSpiel = inZeile ? baueTaste('data-dp-abspielen', 'Abspielen', P_SPIEL, '', true) : null;
      var tasteVor = album ? baueTaste('data-dp-titel-vor', 'Titel vor', 'M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z', 'right', false) : null;

      if (inZeile) {
        /* Der Tonspieler braucht seine eigene Leiste nicht mehr: Cover bleibt frei. */
        try { player.audio.controls = false; player.audio.removeAttribute('controls'); } catch (e) {}

        var zeitEl = document.createElement('span');
        zeitEl.setAttribute('data-dp-zeit', '');
        if (zeitEl.style) {
          zeitEl.style.cssText = 'flex:0 0 auto;margin-left:2px;font-size:1.2rem;line-height:1;white-space:nowrap;' +
            'font-variant-numeric:tabular-nums;color:rgba(var(--color-foreground),.75);';
        }
        zeitEl.textContent = '0:00';
        tastenBox.appendChild(zeitEl);

        /* Umschalter „Nur Ton“ / „Mit Bild“ (nur bei Videos): rechts in der Bedienung, links neben „Teilen“.
           Einzelfolge mit Wort, Album nur mit Zeichen wie die Titel-Tasten (wenig Platz). */
        var P_TON = 'M12 3a9 9 0 0 0-9 9v7a2 2 0 0 0 2 2h3v-8H5v-1a7 7 0 0 1 14 0v1h-3v8h3a2 2 0 0 0 2-2v-7a9 9 0 0 0-9-9z';
        var P_BILD = 'M21 3H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h5v2h8v-2h5a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm0 14H3V5h18v12zm-5-6-7 4V7z';
        umschalt = document.createElement('button');
        umschalt.type = 'button';
        umschalt.setAttribute('data-dp-umschalt', '');
        if (umschalt.style) {
          umschalt.style.cssText = (album ? TASTE : TASTE.replace('width:46px;', 'width:auto;min-width:46px;').replace('flex:0 1 46px;', 'flex:0 0 auto;')) +
            'margin-left:auto;display:none;';
        }
        umschaltFeld = document.createElement('span');
        if (umschaltFeld.style) {
          umschaltFeld.style.cssText = FELD + RAND + (album ? '' : 'gap:5px;padding:0 9px;width:auto;min-width:46px;font-size:1.2rem;line-height:1;white-space:nowrap;');
        }
        umschalt.appendChild(umschaltFeld);
        tastenBox.appendChild(umschalt);
        var eng = 0;              /* schmale Zeile: 1 = Umschalter ohne Wort, 2 = engere Abstände, 3 = nur die gespielte Zeit, 4 = ohne Zeit */
        var nurKurz = false;      /* Stufe 3: Zeit ohne Gesamtlänge */
        var umschaltInhalt = '';  /* zuletzt gesetzter Inhalt (nur bei Änderung neu schreiben) */
        umschaltZeichen = function (ton) {
          var wort = ton ? 'Mit Bild' : 'Nur Ton';
          var mitWort = !album && eng < 1;
          var inhalt = zeichen(ton ? P_BILD : P_TON).replace('display:block', 'display:block;flex:0 0 auto') + (mitWort ? '<span>' + wort + '</span>' : '');
          if (inhalt !== umschaltInhalt) {
            umschaltInhalt = inhalt;
            umschaltFeld.innerHTML = inhalt;
            if (!album && umschaltFeld.style) { umschaltFeld.style.padding = mitWort ? '0 9px' : '0'; }
          }
          umschalt.setAttribute('aria-label', ton ? 'Wieder mit Bild' : 'Nur den Ton hören');
          umschalt.setAttribute('title', wort);
          umschalt.setAttribute('aria-pressed', ton ? 'true' : 'false');
        };

        /* Fortschrittslinie: liegt im Spalt zwischen Medienfeld und Zeile (oberer Innenabstand von
           .dp__inhalt), nichts davon über dem Cover. Die Tippfläche reicht 8 px nach oben. */
        var inhalt = q('.dp__inhalt') || kopf.parentNode || null;
        var leiste = null;
        var fuell = null;
        var griff = null;
        if (inhalt && inhalt.insertBefore && inhalt !== root) {
          var luft = 14;
          try {
            if (window.getComputedStyle) {
              var cs = window.getComputedStyle(inhalt);
              var pt = parseFloat(cs.paddingTop);
              if (isFinite(pt) && pt >= 8) { luft = Math.min(pt, 24); }
              if (cs.position === 'static' && inhalt.style) { inhalt.style.position = 'relative'; }
            }
          } catch (e) {}
          var spurOben = 8 + Math.max(0, Math.floor((luft - 3) / 2));
          leiste = document.createElement('div');
          leiste.setAttribute('data-dp-leiste', '');
          leiste.setAttribute('role', 'slider');
          leiste.setAttribute('tabindex', '0');
          leiste.setAttribute('aria-label', 'Position im Titel');
          leiste.setAttribute('aria-valuemin', '0');
          leiste.setAttribute('aria-valuemax', '100');
          leiste.setAttribute('aria-valuenow', '0');
          if (leiste.style) {
            leiste.style.cssText = 'display:none;position:absolute;z-index:1;left:4px;right:4px;top:-8px;height:' + (8 + Math.round(luft) - 2) + 'px;' +
              'cursor:pointer;outline:none;touch-action:pan-y;-webkit-user-select:none;user-select:none;-webkit-tap-highlight-color:transparent;';
          }
          var spur = document.createElement('span');
          if (spur.style) {
            spur.style.cssText = 'position:absolute;left:0;right:0;top:' + spurOben + 'px;height:3px;border-radius:2px;overflow:hidden;' +
              'background:rgba(var(--color-foreground),.25);pointer-events:none;';
          }
          fuell = document.createElement('span');
          if (fuell.style) { fuell.style.cssText = 'display:block;width:0%;height:100%;background:rgb(var(--color-foreground));'; }
          spur.appendChild(fuell);
          griff = document.createElement('span');
          if (griff.style) {
            griff.style.cssText = 'position:absolute;left:0;top:' + (spurOben - 5) + 'px;width:13px;height:13px;border-radius:50%;' +
              'background:rgb(var(--color-foreground));box-shadow:0 0 0 1px rgba(0,0,0,.35);opacity:0;transition:opacity .15s;pointer-events:none;';
          }
          leiste.appendChild(spur);
          leiste.appendChild(griff);
          inhalt.insertBefore(leiste, inhalt.firstChild || null);
        }

        var gezeigt = false;   /* die Karte hat schon einmal gespielt */
        var istTon = false;    /* es läuft der Tonspieler (Cover), nicht ein Video mit Bild */
        var ziehen = false;    /* Finger oder Maus liegt gerade auf der Linie */
        var ziehAnteil = 0;
        var zeiger = false;
        var fokus = false;
        var stand = {};        /* zuletzt Gezeigtes: nur schreiben, wenn sich etwas ändert */

        var dauer = function () {
          var d = Number(M().duration);
          return isFinite(d) && d > 0 ? d : 0;
        };
        var zeitText = function (s) {
          s = Math.max(0, Math.floor(Number(s) || 0));
          var st = Math.floor(s / 3600);
          var mi = Math.floor((s % 3600) / 60);
          var se = s % 60;
          return (st ? st + ':' + (mi < 10 ? '0' : '') + mi : String(mi)) + ':' + (se < 10 ? '0' : '') + se;
        };
        /* Platz für die Zeit: Zeilenbreite ohne „Teilen“ und ohne die Tasten. */
        var platzWert = 0;
        var platz = function () {
          if (platzWert > 0) { return platzWert; }
          var b = Number(kopf.clientWidth) || 0;
          if (!b) { return 0; }
          var teilen = kopf.querySelector ? kopf.querySelector('.dp__teilen') : null;
          var tb = teilen ? (Number(teilen.offsetWidth) || 0) + 10 : 0;
          var ub = (umschalt && umschalt.style && umschalt.style.display !== 'none') ? (Number(umschalt.offsetWidth) || 52) + 6 : 0;
          platzWert = b - tb - (album ? 3 : 1) * 52 - 2 - ub;
          return platzWert;
        };
        if (window.addEventListener) { window.addEventListener('resize', function () { platzWert = 0; passeZeile(); bedienStand(); }); }

        var bedienStand = function () {
          var el = M();
          var spielt = !el.paused && !el.ended;
          if (stand.spielt !== spielt) {
            stand.spielt = spielt;
            felder['data-dp-abspielen'].innerHTML = zeichen(spielt ? P_PAUSE : P_SPIEL);
            tasteSpiel.setAttribute('aria-label', spielt ? 'Pause' : 'Abspielen');
            tasteSpiel.setAttribute('title', spielt ? 'Pause' : 'Abspielen');
          }
          var d = dauer();
          var t = ziehen ? ziehAnteil * d : (Number(el.currentTime) || 0);
          if (d && t > d) { t = d; }
          var kurz = zeitText(t);
          var lang = d ? kurz + ' / ' + zeitText(d) : kurz;
          var text = (d && !nurKurz && lang.length * 7 <= platz()) ? lang : kurz;
          if (stand.text !== text) {
            var laengeVorher = stand.laenge;
            stand.text = text;
            stand.laenge = text.length;
            zeitEl.textContent = text;
            if (laengeVorher !== text.length) { passeZeile(); }
          }
          if (!leiste) { return; }
          var p = d ? Math.round(t / d * 1000) / 10 : 0;
          if (stand.p !== p) {
            stand.p = p;
            if (fuell.style) { fuell.style.width = p + '%'; }
            if (griff.style) { griff.style.left = 'calc(' + p + '% - ' + (Math.round(13 * p) / 100) + 'px)'; }
            leiste.setAttribute('aria-valuenow', String(Math.round(p)));
          }
          var vt = d ? kurz + ' von ' + zeitText(d) : kurz;
          if (stand.vt !== vt) { stand.vt = vt; leiste.setAttribute('aria-valuetext', vt); }
        };
        var leisteStand = function () {
          if (!leiste || !leiste.style) { return; }
          leiste.style.display = (gezeigt && istTon) ? 'block' : 'none';
          if (griff.style) { griff.style.opacity = (ziehen || zeiger || fokus) ? '1' : '0'; }
        };

        /* Mit dem ersten Abspielen: Bedienung zeigen, die kleine Markenzeile macht ihr Platz. */
        tastenZeigen = function () {
          if (!gezeigt) {
            gezeigt = true;
            if (tastenBox.style) { tastenBox.style.display = 'flex'; }
            var marke = kopf.querySelector ? kopf.querySelector('.dp__marke') : null;
            if (marke && marke.style) { marke.style.display = 'none'; }
            platzWert = 0;
            leisteStand();
          }
          bedienStand();
        };
        /* Tonspieler: Linie zeigen. Video mit Bild: Linie weg, das Video hat seine eigene Bedienung. */
        tastenLage = function (ton) {
          istTon = !!ton;
          leisteStand();
          umschaltStand();
          bedienStand();
        };
        /* Umschalter nur bei Videos (Bild oder dessen Tondatei), nicht bei Audio-Titeln. */
        umschaltStand = function () {
          if (!umschalt || !umschalt.style) { return; }
          var a = player.art();
          var zeigen = gezeigt && aktuellM && (a === 'ton' || (a === 'hls' && !keinTon[aktuellM]));
          var vorher = umschalt.style.display !== 'none';
          umschalt.style.display = zeigen ? 'inline-flex' : 'none';
          if (zeigen) { umschaltZeichen(a === 'ton'); }
          if (vorher !== !!zeigen) { platzWert = 0; stand.text = null; passeZeile(); }
        };
        /* Schmale Zeile (Handy, Album mit Laufzeit über einer Stunde): erst das Wort am Umschalter weglassen,
           dann die Abstände enger, dann nur die gespielte Zeit, zuletzt die Zeit ausblenden. Gemessen wird nur
           bei Änderungen (Umschalter ein/aus, Länge der Zeitangabe, Fenstergröße), nicht bei jedem timeupdate. */
        var passeZeile = function () {
          if (!tastenBox || !tastenBox.style || !(Number(tastenBox.clientWidth) > 0)) { return; }
          var zuViel = function () { return tastenBox.scrollWidth > tastenBox.clientWidth + 1; };
          var stufe = function (n) {
            eng = n;
            nurKurz = n >= 3;
            tastenBox.style.gap = n >= 2 ? '3px' : '6px';
            if (nurKurz && stand.text && stand.text.indexOf(' / ') !== -1) {
              stand.text = stand.text.split(' / ')[0];
              stand.laenge = stand.text.length;
              zeitEl.textContent = stand.text;
            }
            if (zeitEl.style) { zeitEl.style.display = n >= 4 ? 'none' : ''; }
            if (umschalt.style.display !== 'none') { umschaltZeichen(player.art() === 'ton'); }
          };
          var vorher = eng;
          stufe(0);
          while (eng < 4 && zuViel()) { stufe(eng + 1); }
          if (eng !== vorher) { platzWert = 0; }
        };
        umschalt.addEventListener('click', function () {
          var a = player.art();
          var el = M();
          var lief = !el.paused && !el.ended;
          if (a === 'hls') {
            wunschTon = true;
            if (player.alsTon(lief)) { umschaltStand(); return; }
            /* Tondatei noch nicht bereit: holen, dann wechseln (Fingertipp ist vorbei, Ton startet trotzdem,
               der Tonspieler wurde beim ersten Abspielen freigeschaltet). */
            var m = aktuellM;
            zugang(m, false, true).then(function (r) {
              if (m !== aktuellM || player.art() !== 'hls') { return; }
              if (r.status === 200 && r.art === 'ton' && player.alsTon(!video.paused)) { umschaltStand(); return; }
              wunschTon = false;
              keinTon[m] = true;
              umschaltStand();
              melde('Für diesen Titel gibt es den reinen Ton noch nicht. Er kommt automatisch, bitte später noch einmal versuchen.', 'hinweis');
            });
          } else if (a === 'ton') {
            wunschTon = false;
            Promise.resolve(player.mitBild(lief)).then(function () { umschaltStand(); });
          }
        });

        tasteSpiel.addEventListener('click', function () {
          var el = M();
          if (el.paused || el.ended) {
            wach(true);   /* Dauerton im selben Fingertipp (wie im Radio) */
            radioAnhalten(el);   /* 2026-10-25: nicht auf das play-Ereignis warten (Android-App) */
            try {
              var p = el.play();
              if (p && typeof p.catch === 'function') { p.catch(function () {}); }
            } catch (e) {}
          } else {
            try { el.pause(); } catch (e) {}
          }
          bedienStand();
        });

        /* Anzeige nachführen. Nur Ereignis-Arten, die die Engine ohnehin schon nutzt. */
        hoere('play', function () { bedienStand(); });
        hoere('pause', function () { bedienStand(); });
        hoere('loadedmetadata', function (el) { if (el === M()) { bedienStand(); } });
        hoere('timeupdate', function (el) { if (el === M() && !ziehen) { bedienStand(); } });

        if (leiste) {
          var anteilVon = function (e) {
            var r = leiste.getBoundingClientRect ? leiste.getBoundingClientRect() : null;
            if (!r || !(r.width > 0)) { return 0; }
            return Math.min(1, Math.max(0, (Number(e.clientX) - r.left) / r.width));
          };
          var springeAuf = function (sek) {
            var d = dauer();
            if (!d) { return; }
            /* Nicht ganz ans Ende: Der Wechsel zum nächsten Titel soll aus dem Spielen heraus passieren. */
            try { M().currentTime = Math.max(0, Math.min(sek, Math.max(d - 1, 0))); } catch (e) {}
            bedienStand();
          };
          leiste.addEventListener('pointerdown', function (e) {
            if (e.button || !dauer()) { return; }
            ziehen = true;
            ziehAnteil = anteilVon(e);
            try { leiste.setPointerCapture(e.pointerId); } catch (x) {}
            if (e.preventDefault) { e.preventDefault(); }
            leisteStand();
            bedienStand();
          });
          leiste.addEventListener('pointermove', function (e) {
            if (!ziehen) { return; }
            ziehAnteil = anteilVon(e);
            bedienStand();
          });
          leiste.addEventListener('pointerup', function (e) {
            if (!ziehen) { return; }
            ziehAnteil = anteilVon(e);
            ziehen = false;
            leisteStand();
            springeAuf(ziehAnteil * dauer());
          });
          /* Das Handy hat die Bewegung als Scrollen der Seite gewertet: nichts verstellen. */
          leiste.addEventListener('pointercancel', function () {
            if (!ziehen) { return; }
            ziehen = false;
            leisteStand();
            bedienStand();
          });
          leiste.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { zeiger = true; leisteStand(); } });
          leiste.addEventListener('pointerleave', function () { zeiger = false; leisteStand(); });
          leiste.addEventListener('focus', function () {
            var sichtbar = true;
            try { if (leiste.matches) { sichtbar = leiste.matches(':focus-visible'); } } catch (e) {}
            fokus = sichtbar;
            leisteStand();
          });
          leiste.addEventListener('blur', function () { fokus = false; leisteStand(); });
          leiste.addEventListener('keydown', function (e) {
            var schritt = e.key === 'ArrowRight' ? 5 : e.key === 'ArrowLeft' ? -5 : 0;
            if (!schritt) { return; }
            if (e.preventDefault) { e.preventDefault(); }
            springeAuf((Number(M().currentTime) || 0) + schritt);
          });
        }
      } else {
        tastenLage = function (ton) {
          [tasteZurueck, tasteVor].forEach(function (b) {
            if (!b.style) { return; }
            b.style.bottom = ton ? '56px' : 'auto';
            b.style.top = ton ? 'auto' : '50%';
            b.style.transform = ton ? 'none' : 'translateY(-50%)';
          });
        };
      }
      if (album) {
        tastenStand = function () {
          var n = freierNachbar(1);
          tasteVor.disabled = !n;
          if (tasteVor.style) { tasteVor.style.opacity = n ? '1' : '.35'; tasteVor.style.cursor = n ? 'pointer' : 'default'; }
        };
        tasteZurueck.addEventListener('click', function () {
          var vor = freierNachbar(-1);
          var el = M();
          var t = Number(el.currentTime) || 0;
          if (t > 3 || !vor) { try { el.currentTime = 0; } catch (e) {} return; }
          spiele(vor.m, true);
        });
        tasteVor.addEventListener('click', function () {
          var n = freierNachbar(1);
          if (n) { spiele(n.m, true); }
        });
      }
    }

    /* Sperrbildschirm: Titel, Künstler, Album, Cover und Bedienung ans Handy melden. */
    if (video && MS) {
      var albumText = ((q('.dp__titel') || {}).textContent || '').trim();
      var kuenstler = ((q('.dp__artist') || {}).textContent || '').trim() || 'DNTK-PLUS';
      var meinMeta = null;

      var freieFolgen = function () {
        return folgen.filter(function (f) { return zeilen[f.m] && zeilen[f.m].getAttribute('data-zustand') === 'frei'; });
      };
      var nachbar = function (schritt) {
        var frei = freieFolgen();
        for (var i = 0; i < frei.length; i++) {
          if (frei[i].m === aktuellM) { return frei[i + schritt] || (schritt > 0 && frei.length > 1 ? frei[0] : null); }
        }
        return null;
      };
      var position = function () {
        if (!sitzung || sitzung.video !== video || !MS.setPositionState) { return; }
        var v = M();
        var d = Number(v.duration);
        if (!isFinite(d) || d <= 0) { return; }
        var p = Math.min(Math.max(Number(v.currentTime) || 0, 0), d);
        try { MS.setPositionState({ duration: d, playbackRate: Number(v.playbackRate) || 1, position: p }); } catch (e) {}
      };
      var springe = function (sek) {
        var v = M();
        var d = Number(v.duration);
        var t = (Number(v.currentTime) || 0) + sek;
        if (isFinite(d) && d > 0) { t = Math.min(t, Math.max(d - 1, 0)); }
        try { v.currentTime = Math.max(0, t); } catch (e) {}
        position();
      };
      var weiterSpielen = function () {
        if (imHintergrund() && zuTon(true)) { return; }   /* Etappe 5d: im Hintergrund als Ton */
        wach(true);
        radioAnhalten(M());   /* 2026-10-25: nicht auf das play-Ereignis warten (Android-App) */
        var p = M().play();
        if (p && typeof p.catch === 'function') { p.catch(function () {}); }
      };
      var meldeTitel = function () {
        var f = null;
        folgen.forEach(function (x) { if (x.m === aktuellM) { f = x; } });
        var bild = f && f.poster ? f.poster : '';
        try {
          meinMeta = new MediaMetadata({
            title: (f && f.titel) || albumText || 'DNTK-PLUS',
            artist: kuenstler,
            album: albumText,
            artwork: bild ? [96, 256, 512].map(function (b) { return { src: coverAdresse(bild, b), sizes: b + 'x' + b }; }) : []
          });
          MS.metadata = meinMeta;
        } catch (e) { meinMeta = null; }
        msAktion('play', weiterSpielen);
        msAktion('pause', function () { M().pause(); });
        msAktion('stop', function () { M().pause(); });
        msAktion('seekto', function (d) {
          if (!d || !isFinite(d.seekTime)) { return; }
          try {
            var v = M();
            if (d.fastSeek && typeof v.fastSeek === 'function') { v.fastSeek(d.seekTime); }
            else { v.currentTime = d.seekTime; }
          } catch (e) {}
          position();
        });
        /* Album/Staffel: Vor und Zurück über die freigeschalteten Titel, dieselben Tasten wie im Radio.
           Spulen wird dann nicht angemeldet: iPhones zeigen sonst die Spul-Tasten anstelle der
           Titel-Tasten, die Skip-Tasten fehlen. Der Fortschrittsbalken (seekto) bleibt.
           Einzelfolge: Spulen (15 s zurück, 30 s vor) statt Vor/Zurück. */
        if (folgen.length > 1) {
          msAktion('seekbackward', null);
          msAktion('seekforward', null);
          msAktion('previoustrack', function () {
            var vor = nachbar(-1);
            var jetztZeit = Number(M().currentTime) || 0;
            if (jetztZeit > 3 || !vor) { springe(-jetztZeit); return; }
            spiele(vor.m, true);
          });
          var nach = nachbar(1);
          msAktion('nexttrack', nach ? function () { var n = nachbar(1); if (n) { spiele(n.m, true); } } : null);
        } else {
          msAktion('seekbackward', function (d) { springe(-((d && d.seekOffset) || 15)); });
          msAktion('seekforward', function (d) { springe((d && d.seekOffset) || 30); });
          msAktion('previoustrack', null);
          msAktion('nexttrack', null);
        }
      };

      hoere('play', function () {
        if (!sitzung || sitzung.video !== video) {
          if (sitzung) {
            var alt = sitzung;
            sitzung = null;
            try { if (alt.anhalten) { alt.anhalten(); } else if (!alt.video.paused) { alt.video.pause(); } } catch (e) {}
          } else {
            try { fremdeMeta = MS.metadata || null; } catch (e) { fremdeMeta = null; }
          }
        }
        radioAnhalten(video);
        meldeTitel();
        sitzung = { video: video, meta: meinMeta, anhalten: anhalten };
        try { MS.playbackState = 'playing'; } catch (e) {}
        position();
      });
      hoere('pause', function (el) {
        if (el !== M()) { return; }   /* der andere Spieler der Karte wurde nur abgelöst */
        if (!sitzung || sitzung.video !== video) { return; }
        try { MS.playbackState = 'paused'; } catch (e) {}
        position();
      });
      ['loadedmetadata', 'durationchange', 'ratechange', 'seeked'].forEach(function (ereignis) {
        hoere(ereignis, function (el) { if (el === M()) { position(); } });
      });
      var zuletzt = 0;
      hoere('timeupdate', function (el) {
        if (el !== M()) { return; }
        var jetzt = Date.now();
        if (jetzt - zuletzt < 1000) { return; }
        zuletzt = jetzt;
        position();
      });
    }

    /* Rueckfall wie v2: je Folge premium-zugang fragen */
    function pruefe(m) {
      return zugang(m, false).then(function (r) {
        if (r.status === 200) { setzeZeile(m, 'frei'); return 'frei'; }
        if (r.status === 401) { neuLaden(melde); setzeZeile(m, 'gesperrt'); return 'fehler'; }
        if (r.status === 409) { setzeZeile(m, 'bald'); return 'bald'; }
        if (r.status === 503) { setzeZeile(m, 'gesperrt'); return 'aus'; }
        setzeZeile(m, 'gesperrt');
        return r.status === 403 ? 'gesperrt' : 'fehler';
      });
    }

    /* besitzt = der Kunde besitzt das Angebot (Berechtigung je Angebot). Dann nie die Kaufbox:
       Neu hinzugefügte Titel stehen auf „Wird eingerichtet“, bis premium-sync sie geprüft hat. */
    function abschluss(ergebnis, besitzt) {
      var alleFrei = ergebnis.length > 0 && ergebnis.every(function (e) { return e === 'frei'; });
      if (alleFrei || besitzt) {
        if (kaufbox) { kaufbox.hidden = true; }
        if (pauseEl) { pauseEl.hidden = true; }
        if (fertigEl) { fertigEl.hidden = false; }
        schreib(FLAG_AUFLADEN, null);
      } else {
        if (fertigEl) { fertigEl.hidden = true; }
        zeigeKaufbox();
      }
      if (besitzt && !alleFrei) {
        melde('Neu in diesem Angebot: Wird gerade eingerichtet und ist in wenigen Minuten für Dich da.', 'hinweis');
      } else if (ergebnis.indexOf('aus') !== -1) {
        melde('Der Verkauf ist gerade noch nicht eingerichtet. Bitte versuche es später noch einmal.', 'hinweis');
      } else if (ergebnis.indexOf('fehler') !== -1 && !alleFrei) {
        melde('Der Status ließ sich gerade nicht prüfen. Bitte lade die Seite gleich noch einmal.', 'hinweis');
      }
      return ergebnis;
    }

    function pruefeAlle(frisch) {
      return besitz(frisch).then(function (b) {
        if (!b) {
          return Promise.all(folgen.map(function (f) { return pruefe(f.m); })).then(abschluss);
        }
        var besitzt = !!(C.handle && b.angebote && b.angebote[C.handle] === 'ganz');
        var ergebnis = folgen.map(function (f) {
          var zustand = b.medien[f.m] ? 'frei' : (besitzt ? 'bald' : 'gesperrt');
          setzeZeile(f.m, zustand);
          return zustand;
        });
        return abschluss(ergebnis, besitzt);
      });
    }

    function ersteFreie() {
      for (var i = 0; i < folgen.length; i++) {
        if (zeilen[folgen[i].m] && zeilen[folgen[i].m].getAttribute('data-zustand') === 'frei') { return folgen[i].m; }
      }
      return null;
    }

    /* ------------------------------------------------------------ Kaufbox */
    function zeigeGuthaben() {
      if (guthabenEl) { guthabenEl.textContent = euro(K.guthaben); }
    }

    function merkeAufladen() {
      schreib(FLAG_AUFLADEN, String(Date.now()));
      melde('Nach dem Bezahlen hier auf „Guthaben prüfen“ tippen.', 'hinweis');
    }

    function zeigeKaufbox(stufeVomServer) {
      if (!kaufbox) { return; }
      if (!C.im_verkauf) {
        kaufbox.hidden = true;
        if (pauseEl) { pauseEl.hidden = false; }
        return;
      }
      kaufbox.hidden = false;
      var genug = K.guthaben >= C.preis;
      if (kaufbereich) { kaufbereich.hidden = !genug; }
      if (aufladenBox) { aufladenBox.hidden = genug; }
      if (genug) { return; }

      var fehlt = C.preis - K.guthaben;
      if (fehltEl) {
        fehltEl.textContent = 'Dir fehlen ' + euro(fehlt) + '. Lade Deine Shopping-Power auf, danach geht es hier mit einem Klick weiter.';
      }

      var liste = (K.stufen || []).slice().sort(function (a, b) { return a[0] - b[0]; });
      var empfohlen = null;
      if (stufeVomServer) {
        liste.forEach(function (st) { if (st[0] === Number(stufeVomServer) * 100) { empfohlen = st; } });
      }
      if (!empfohlen) {
        liste.forEach(function (st) { if (!empfohlen && st[0] >= fehlt) { empfohlen = st; } });
      }
      if (!empfohlen && liste.length) { empfohlen = liste[liste.length - 1]; }

      if (!stufenBox) { return; }
      stufenBox.innerHTML = '';
      if (!liste.length) {
        var ersatz = document.createElement('a');
        ersatz.href = '/products/guthaben-aufladen';
        ersatz.target = '_blank';
        ersatz.rel = 'noopener';
        ersatz.className = 'button button--primary';
        ersatz.textContent = 'Shopping-Power aufladen';
        ersatz.addEventListener('click', merkeAufladen);
        stufenBox.appendChild(ersatz);
        return;
      }
      liste.forEach(function (st) {
        var a = document.createElement('a');
        a.href = '/cart/' + st[1] + ':1';
        a.target = '_blank';
        a.rel = 'noopener';
        a.className = 'button ' + (st === empfohlen ? 'button--primary' : 'button--secondary');
        a.textContent = euro(st[0]) + ' aufladen';
        a.addEventListener('click', merkeAufladen);
        stufenBox.appendChild(a);
      });
    }

    var kaufLaeuft = false;
    if (haken && knopf) {
      haken.addEventListener('change', function () { knopf.disabled = !haken.checked || kaufLaeuft; });
    }
    if (neuKnopf) {
      neuKnopf.addEventListener('click', function () { window.location.reload(); });
    }
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible' && lies(FLAG_AUFLADEN) && aufladenBox && !aufladenBox.hidden) {
        melde('Zurück vom Aufladen? Tippe auf „Guthaben prüfen“. Die Gutschrift kann ein bis zwei Minuten dauern.', 'hinweis');
      }
    });

    function kaufeJetzt() {
      if (kaufLaeuft || !knopf) { return; }
      if (!haken || !haken.checked) {
        melde('Bitte bestätige zuerst das Häkchen zum sofortigen Abspielen.', 'hinweis');
        if (haken) { haken.focus(); }
        return;
      }
      kaufLaeuft = true;
      knopf.disabled = true;
      knopf.setAttribute('aria-busy', 'true');
      melde('Wird freigeschaltet …', '');

      kaufen(C.variante, C.handle).then(function (a) {
        var j = a.j;
        if (a.status === 200 && j.ok) {
          if (!j.schon) {
            K.guthaben = Math.max(0, K.guthaben - zuCent(j.betrag));
            zeigeGuthaben();
          }
          schreib(FLAG_AUFLADEN, null);
          melde(j.schon ? 'Du hast das schon gekauft. Viel Spaß!'
                        : 'Gekauft und freigeschaltet' + (j.bestellung ? ' (Bestellung ' + j.bestellung + ')' : '') + '. Viel Spaß!', 'ok');
          return pruefeAlle(true).then(function () {
            markiere(document);
            var m = ersteFreie();
            if (m) { spiele(m, true); }
          });
        }
        if (a.status === 402) {
          K.guthaben = zuCent(j.guthaben);
          if (j.preis) { C.preis = zuCent(j.preis) || C.preis; }
          zeigeGuthaben();
          zeigeKaufbox(j.stufe);
          melde('Deine Shopping-Power reicht noch nicht. Dir fehlen ' + euro(zuCent(j.fehlt)) + '.', 'hinweis');
          return;
        }
        if (a.status === 401) { neuLaden(melde); return; }
        if (a.status === 409 && j.grund === 'nicht_im_verkauf') {
          melde('Diese Folge ist gerade nicht im Verkauf.', 'fehler');
          return;
        }
        if (a.status === 409) {
          melde('Deine Freischaltung läuft bereits. Einen Moment …', '');
          return warte(4000).then(function () { return pruefeAlle(true); });
        }
        if (a.status === 400 && j.grund === 'widerruf') {
          melde('Bitte bestätige zuerst das Häkchen zum sofortigen Abspielen.', 'hinweis');
          return;
        }
        if (a.status === 503) {
          melde('Der Verkauf ist gerade noch nicht eingerichtet. Bitte versuche es später noch einmal.', 'fehler');
          return;
        }
        if (j.text && j.text.indexOf('pruefen') !== -1) {
          melde('Die Freischaltung ist fehlgeschlagen. Wir prüfen Dein Guthaben und melden uns bei Dir.', 'fehler');
          return;
        }
        melde('Das hat nicht geklappt, Dein Guthaben ist unverändert. Bitte versuche es gleich noch einmal.', 'fehler');
      }).catch(function () {
        /* Keine Antwort heisst nicht "nichts passiert": nachsehen statt noch einmal kaufen. */
        melde('Keine Antwort erhalten. Wir sehen nach, ob die Freischaltung geklappt hat …', 'hinweis');
        return warte(3000).then(function () { return pruefeAlle(true); });
      }).then(function () {
        kaufLaeuft = false;
        knopf.removeAttribute('aria-busy');
        knopf.disabled = !(haken && haken.checked);
      });
    }
    if (knopf) { knopf.addEventListener('click', kaufeJetzt); }

    /* ------------------------------------------------------------- Abspielen */
    function spiele(m, sofort) {
      if (!player) { return; }
      if (aktuellM && aktuellM !== m) { sichere(true); zeigeStellen(); }   /* Stelle des bisherigen Titels behalten und zeigen */
      aktuellM = m;
      ruheBis = Date.now() + 4000;
      if (playerBox) { playerBox.hidden = false; }
      var titel = '';
      var poster = '';
      folgen.forEach(function (f) { if (f.m === m) { titel = f.titel || ''; poster = f.poster || ''; } });
      if (jetztEl) { jetztEl.textContent = titel; }
      Object.keys(zeilen).forEach(function (k) { zeilen[k].setAttribute('data-aktiv', k === m ? '1' : '0'); });
      tastenZeigen();  /* Bedienung in der Zeile unter dem Medienfeld einblenden */
      tastenStand();   /* „Titel vor“ ausgrauen, wenn es keinen anderen freigeschalteten Titel gibt */
      /* Hat diese Karte schon die Bedienung (Titelwechsel im Album), den neuen Titel gleich melden:
         Beim Wechsel ohne Zwischenhalt ist nicht sicher, dass das Handy ein neues „play“ meldet. */
      if (typeof meldeTitel === 'function' && sitzung && sitzung.video === video) {
        meldeTitel();
        sitzung.meta = meinMeta;
      }
      if (sofort) { wach(true); }   /* Dauerton im selben Fingertipp starten (wie im Radio) */
      var st = stelle(m);
      return player.spiele(m, { poster: poster, ton: imHintergrund() || wunschTon, ab: st ? st.p : 0 }, sofort).catch(function () {
        if (zeilen[m] && zeilen[m].getAttribute('data-zustand') === 'bald') {
          melde('Diese Folge wird gerade noch eingerichtet. Bitte versuche es etwas später.', 'hinweis');
          return;
        }
        melde('Die Folge lässt sich gerade nicht laden. Bitte versuche es gleich noch einmal.', 'fehler');
      });
    }

    Object.keys(zeilen).forEach(function (m) {
      var b = zeilen[m].querySelector('[data-dp-spielen]');
      if (!b) { return; }
      b.addEventListener('click', function () {
        if (zeilen[m].getAttribute('data-zustand') !== 'frei') { return; }
        spiele(m, true);
        if (playerBox && playerBox.scrollIntoView) { playerBox.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      });
    });

    /* ------------------------------------------------------------- Start */
    zeigeGuthaben();
    pruefeAlle(false).then(function () {
      var gemerkt = Number(lies(FLAG_AUFLADEN)) || 0;
      if (!gemerkt || (kaufbox && kaufbox.hidden)) { return; }
      if (Date.now() - gemerkt > 86400000) { schreib(FLAG_AUFLADEN, null); return; }
      if (K.guthaben >= C.preis) {
        schreib(FLAG_AUFLADEN, null);
        melde('Aufladung angekommen. Häkchen setzen und kaufen, fertig.', 'ok');
        if (kaufbox.scrollIntoView) { kaufbox.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      } else {
        melde('Deine Aufladung ist noch nicht angekommen. Das kann ein bis zwei Minuten dauern, dann „Guthaben prüfen“.', 'hinweis');
      }
    });
  }

  /* ------------------------------------------------------------- Start */
  window.DNTKPremium = {
    konfig: K,
    aktiv: AKTIV,
    besitz: besitz,
    markiere: markiere,
    zugang: zugang,
    kaufen: kaufen,
    kennung: kennung,
    neuerPlayer: neuerPlayer,
    bindeAngebot: bindeAngebot,
    euro: euro
  };

  function starteAlles(wurzel) {
    Array.prototype.forEach.call((wurzel || document).querySelectorAll('[data-dntk-premium-angebot]'), bindeAngebot);
    markiere(wurzel || document);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { starteAlles(document); });
  } else {
    starteAlles(document);
  }
  /* Theme-Editor: neu gerenderte Sections verdrahten */
  document.addEventListener('shopify:section:load', function (e) { starteAlles(e.target); });
})();
